import axios from 'axios';
import { toast } from 'react-toastify';

/**
 * @description Sends a Get request to api
 * @param {String} route
 * @example "/api/route"
 * @returns Promise<any>
 */
const Get = async (
  route,
  accessToken,
  companyId,
  showAlert = true,
  callback,
  responseType,
) => {
  const options = accessToken
    ? {
        ...(responseType && { responseType: responseType }),
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
          ...(companyId && { 'company-id': companyId }),
        },
      }
    : {
        ...(responseType && { responseType: responseType }),
        headers: {
          Accept: 'application/json',
          ...(companyId && { 'company-id': companyId }),
        },
      };
  try {
    const response = await axios.get(route, options);
    return response;
  } catch (error) {
    if (error?.response?.status * 1 == 401) {
      toast.error('User is unauthorized', {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem('persist:root');
      if (!window.location.pathname.includes('login')) {
        window.location.href = '/login';
      }
    }
    let errorMessage = '';
    Array.isArray(error?.response?.data?.message?.error)
      ? error?.response?.data?.message?.error?.map(
          (item, i) => (errorMessage = `${errorMessage} • ${item} \n`),
        )
      : (errorMessage = error?.response?.data?.message?.error);
    if (showAlert == true) {
      if (!route.includes('users/get-runtime-data')) {
        if (error.message === 'Network Error') {
          // toast.error(`${error.message} : Please Check Your Network Connection`, {
          //   position: toast.POSITION.TOP_CENTER,
          // });
        } else {
          toast.error(errorMessage, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    }
    if (!route.includes('users/get-runtime-data')) {
      callback && callback(error);
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 * @returns Promise<any>
 */
// Some pages pass the bare access token where request options belong (the Leads page:
// Post(url, body, accessToken)). Spreading a string sent no Authorization header at all,
// so those calls only worked on routes that had no login check.
const asOptions = (headers) =>
  typeof headers === 'string' && headers ? { headers: { Authorization: `Bearer ${headers}` } } : headers;

const Post = async (route, data, headers, companyId, showAlert = true) => {
  headers = asOptions(headers);
  const options = {
    ...headers,
    headers: {
      ...headers?.headers,
      ...(companyId && { 'company-id': companyId }),
    },
  };

  try {
    return await axios.post(route, data, options);
  } catch (error) {
    if (route.includes('zoom/')) throw error;

    if (error?.response?.status * 1 == 401) {
      toast.error('User is unauthorized', {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem('persist:root');
      if (!window.location.pathname.includes('login')) {
        window.location.href = '/login';
      }
    }
    let errorMessage = '';
    Array.isArray(error?.response?.data?.message?.error)
      ? error?.response?.data?.message?.error?.map(
          (item, i) => (errorMessage = `${errorMessage} • ${item} \n`),
        )
      : (errorMessage = error?.response?.data?.message?.error);
    if (error.message === 'Network Error') {
      // toast.error(`${error.message} : Please Check Your Network Connection`, {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    } else {
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */
const Patch = async (route, data, headers, companyId, showAlert = true) => {
  headers = asOptions(headers);
  const options = {
    ...headers,
    headers: {
      ...headers?.headers,
      ...(companyId && { 'company-id': companyId }),
    },
  };

  try {
    return await axios.patch(route, data, options);
  } catch (error) {
    if (error?.response?.status * 1 == 401) {
      toast.error('User is unauthorized', {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem('persist:root');
      if (!window.location.pathname.includes('login')) {
        window.location.href = '/login';
      }
    }
    let errorMessage = '';
    Array.isArray(error?.response?.data?.message?.error)
      ? error?.response?.data?.message?.error?.map(
          (item, i) => (errorMessage = `${errorMessage} • ${item} \n`),
        )
      : (errorMessage = error?.response?.data?.message?.error);
    if (error.message === 'Network Error') {
      // toast.error(`${error.message} : Please Check Your Network Connection`, {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    } else {
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_CENTER,
      });
    }

    return error;
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */
const Put = async (route, data, headers, showAlert = true) => {
  headers = asOptions(headers);
  try {
    return await axios.put(route, data, headers);
  } catch (error) {
    if (error?.response?.status * 1 == 401) {
      toast.error('User is unauthorized', {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem('persist:root');
      if (!window.location.pathname.includes('login')) {
        window.location.href = '/login';
      }
    }
    let errorMessage = '';
    Array.isArray(error?.response?.data?.message?.error)
      ? error?.response?.data?.message?.error?.map(
          (item, i) => (errorMessage = `${errorMessage} • ${item} \n`),
        )
      : (errorMessage = error?.response?.data?.message?.error);
    if (error.message === 'Network Error') {
      // toast.error(`${error.message} : Please Check Your Network Connection`, {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    } else {
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
};

/**
 * @description Sends a Delete request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */
const Delete = async (route, data, headers, companyId, showAlert = true) => {
  try {
    // Some callers use the short form Delete(route, apiHeader(token)): the
    // second argument is then the headers, not a body.
    if (headers === undefined && data?.headers) {
      headers = data;
      data = null;
    }
    // ...or Delete(route, accessToken): a bare token string in the body's place.
    if (headers === undefined && typeof data === 'string' && data.length > 20) {
      headers = data;
      data = null;
    }
    headers = asOptions(headers);
    const options = {
      ...headers,
      headers: {
        ...headers?.headers,
        ...(companyId && { 'company-id': companyId }),
      },
    };
    // axios.delete takes (url, config) only. Passing the body as a second
    // argument used to swallow the login header, so the server answered 401
    // and the user was logged out (e.g. Extraction review, Remove from run).
    return await axios.delete(
      route,
      data == null ? options : { ...options, data },
    );
  } catch (error) {
    if (error?.response?.status * 1 == 401) {
      toast.error('User is unauthorized', {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem('persist:root');
      if (!window.location.pathname.includes('login')) {
        window.location.href = '/login';
      }
    }
    let errorMessage = '';
    Array.isArray(error?.response?.data?.message?.error)
      ? error?.response?.data?.message?.error?.map(
          (item, i) => (errorMessage = `${errorMessage} • ${item} \n`),
        )
      : (errorMessage = error?.response?.data?.message?.error);
    if (error.message === 'Network Error') {
      // toast.error(`${error.message} : Please Check Your Network Connection`, {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    } else {
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
};

export { Post, Put, Get, Patch, Delete };
